import Vue from 'vue';
import { Collection } from '@/types';

import VueCompositionAPI from '@vue/composition-api';

import { provideTeamIdKey } from '@/modules/teamplan/utils/provideTeamId';
import { setupPaypalButton } from '@/modules/account-settings/utils/setupPaypalButton';

export default {
  'portal-target': props => {
    return new Vue({
      render: h => h('portal-target', { props }),
    });
  },

  /* mypage */
  'my-page-template': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/mypage/templates/MyPageTemplate.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  // 公募管理の公募一覧ページ
  'requester-issues-template': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/mypage/templates/RequesterIssuesTemplate.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  // 公募管理の公募詳細ページ
  'requester-issue-detail-template': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/mypage/templates/RequesterIssueDetailTemplate.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'requester-proposals-template': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/mypage/templates/RequesterProposalsTemplate.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'requester-receipt-template': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/mypage/templates/RequesterReceiptTemplate.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'requester-receipt-invoice-template': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/mypage/templates/RequesterReceiptInvoiceTemplate.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'all-requester-receipt-invoices-template': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/mypage/templates/AllRequesterReceiptInvoicesTemplate.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'advisor-proposals-template': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/mypage/templates/AdvisorProposalsTemplate.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'my-page-request-tutorial-modal': props => {
    const Component = () =>
      import('@/modules/mypage/organisms/MyPageRequestTutorialModal.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'my-page-no-job-history-warning-modal': props => {
    const Component = () =>
      import('@/modules/mypage/organisms/MyPageNoJobHistoryWarningModal.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'my-page-no-residence-warning-modal': props => {
    const Component = () =>
      import('@/modules/mypage/organisms/MyPageNoResidenceWarningModal.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'requester-payments-template': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/mypage/templates/RequesterPaymentsTemplate.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* mypage (SP) */
  'my-page-template-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/mypage/templates/MyPageTemplateSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  // 公募管理の公募一覧ページ SP
  'requester-issues-template-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/mypage/templates/RequesterIssuesTemplateSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  // 公募管理の公募詳細ページ SP
  'requester-issue-detail-template-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/mypage/templates/RequesterIssueDetailTemplateSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'requester-proposals-template-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/mypage/templates/RequesterProposalsTemplateSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'advisor-proposals-template-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/mypage/templates/AdvisorProposalsTemplateSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'requester-payments-template-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/mypage/templates/RequesterPaymentsTemplateSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  // TODO: 削除予定(https://app.clickup.com/t/86ep2k4du)
  /* proposal */
  // 'advisor-proposal-page': props => {
  //   import('@/helpers/fullstoryErrorLogging');
  //   Vue.use(VueCompositionAPI);
  //   const Component = () =>
  //     import('@/modules/proposal/pages/AdvisorProposalPage.vue');
  //   return new Vue({
  //     render: h => h(Component, { props }),
  //   });
  // },
  'requester-proposal-page': props => {
    import('@/helpers/fullstoryErrorLogging');
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/proposal/pages/RequesterProposalPage.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'my-page-advice-tutorial-modal-sp': props => {
    const Component = () =>
      import('@/modules/mypage/organisms/MyPageAdviceTutorialModalSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'my-page-request-tutorial-modal-sp': props => {
    const Component = () =>
      import('@/modules/mypage/organisms/MyPageRequestTutorialModalSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'my-page-no-job-history-warning-modal-sp': props => {
    const Component = () =>
      import('@/modules/mypage/organisms/MyPageNoJobHistoryWarningModalSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  // TODO: 削除予定(https://app.clickup.com/t/86ep2k4du)
  /* proposal (SP) */
  // 'advisor-proposal-page-sp': props => {
  //   import('@/helpers/fullstoryErrorLogging');
  //   Vue.use(VueCompositionAPI);
  //   const Component = () =>
  //     import('@/modules/proposal/pages/AdvisorProposalPageSP.vue');
  //   return new Vue({
  //     render: h => h(Component, { props }),
  //   });
  // },
  'requester-proposal-page-sp': props => {
    import('@/helpers/fullstoryErrorLogging');
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/proposal/pages/RequesterProposalPageSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* proposal (iOS WebView) */
  'questionnaire-template-for-web-view': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/proposal/templates/QuestionnaireTemplateForWebView.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'advisor-requester-profile-page-for-web-view': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/proposal/pages/AdvisorRequesterProfilePageForWebView.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* topic */
  'topic-detail-page': props => {
    Vue.use(VueCompositionAPI);
    const Component = () => import('@/modules/topic/pages/TopicPage.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* topic (SP) */
  'topic-detail-page-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () => import('@/modules/topic/pages/TopicPageSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* topics */
  'topics-auto-complete': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/topics/organisms/TopicsAutoComplete.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* public-issue */
  // TODO: 後ほどファイル削除と同タイミングで削除対応 CU-86enzqnam
  // 'public-issue-detail': props => {
  //   Vue.use(VueCompositionAPI);
  //   const Component = () =>
  //     import('@/modules/public-issue/apps/PublicIssueDetailApp.vue');
  //   return new Vue({
  //     render: h => h(Component, { props }),
  //   });
  // },
  // 'public-issue-detail-sp': props => {
  //   Vue.use(VueCompositionAPI);
  //   const Component = () =>
  //     import('@/modules/public-issue/apps/PublicIssueDetailAppSP.vue');
  //   return new Vue({
  //     render: h => h(Component, { props }),
  //   });
  // },
  'public-issue-register-template': async props => {
    const Component = () =>
      import(
        '@/modules/public-issue-register/templates/PublicIssueRegisterTemplate.vue'
      );
    const { router, setMixpanelTracking } = await import(
      '@/modules/public-issue-register/routers/publicIssueRegisterRouter'
    );
    setMixpanelTracking(props);
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },
  'public-issue-register-template-sp': async props => {
    const Component = () =>
      import(
        '@/modules/public-issue-register/templates/PublicIssueRegisterTemplateSP.vue'
      );
    const { router, setMixpanelTracking } = await import(
      '@/modules/public-issue-register/routers/publicIssueRegisterRouterSP'
    );
    setMixpanelTracking(props);
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },
  'public-issue-published-template': props => {
    const Component = () =>
      import(
        '@/modules/public-issue-register/templates/PublicIssuePublishedTemplate.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'public-issue-published-template-sp': props => {
    const Component = () =>
      import(
        '@/modules/public-issue-register/templates/PublicIssuePublishedTemplateSP.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* public-issue-propose */
  // TODO: 後ほどファイル削除と同タイミングで削除対応 CU-86enzqnam
  // 'public-issue-propose-page': async props => {
  //   Vue.use(VueCompositionAPI);
  //   const Component = () =>
  //     import(
  //       '@/modules/public-issue-propose/pages/PublicIssueProposeRouterViewPage.vue'
  //     );
  //   const { router } = await import(
  //     '@/modules/public-issue-propose/routers/publicIssueProposeRouter'
  //   );
  //   return new Vue({
  //     router,
  //     render: h => h(Component, { props }),
  //   });
  // },

  /* public-issue-propose-sp */
  // TODO: 後ほどファイル削除と同タイミングで削除対応 CU-86enzqnam
  // 'public-issue-propose-page-sp': async props => {
  //   Vue.use(VueCompositionAPI);
  //   const Component = () =>
  //     import(
  //       '@/modules/public-issue-propose/pages/PublicIssueProposeRouterViewPage.vue'
  //     );
  //   const { router } = await import(
  //     '@/modules/public-issue-propose/routers/publicIssueProposeRouterSP'
  //   );
  //   return new Vue({
  //     router,
  //     render: h => h(Component, { props }),
  //   });
  // },

  /* private-issue-propose */
  'private-issue-propose-page': async props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/private-issue-propose/pages/PrivateIssueProposeRouterViewPage.vue'
      );
    const { router } = await import(
      '@/modules/private-issue-propose/routers/privateIssueProposeRouter'
    );
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },

  /* private-issue-propose-sp */
  'private-issue-propose-page-sp': async props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/private-issue-propose/pages/PrivateIssueProposeRouterViewPage.vue'
      );
    const { router } = await import(
      '@/modules/private-issue-propose/routers/privateIssueProposeRouterSP'
    );
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },

  /* register */
  'register-user-verification-page': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/register/pages/RegisterUserVerificationPage.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'register-tel-page': props => {
    const Component = () =>
      import('@/modules/register/pages/RegisterTelPage.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'register-requester-position-page': props => {
    Vue.use(VueCompositionAPI);
    const Component = () => {
      return import(
        '@/modules/register/pages/RegisterRequesterPositionPage.vue'
      );
    };
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'register-requester-usage-page': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-register/pages/AccountRegisterRequesterUsagePage.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* register (SP) */
  'register-user-verification-page-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/register/pages/RegisterUserVerificationPageSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'register-tel-page-sp': props => {
    const Component = () =>
      import('@/modules/register/pages/RegisterTelPageSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'register-requester-position-page-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/register/pages/RegisterRequesterPositionPageSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'register-requester-usage-page-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-register/pages/AccountRegisterRequesterUsagePageSP.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* account-register */
  'account-register': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/account-register/apps/AccountRegisterApp.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'account-register-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/account-register/apps/AccountRegisterAppSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  // TODO: エキスパート向けの不要なコードを削除する CU-86ep3r2qx
  // 'account-register-advisor': async props => {
  //   Vue.use(VueCompositionAPI);
  //   const Component = () =>
  //     import('@/modules/account-register/apps/AccountRegisterAdvisorApp.vue');
  //   const { router } = await import(
  //     '@/modules/account-register/routers/accountRegisterAdvisorRouter'
  //   );
  //   return new Vue({
  //     router,
  //     render: h => h(Component, { props }),
  //   });
  // },
  // 'account-register-advisor-sp': async props => {
  //   Vue.use(VueCompositionAPI);
  //   const Component = () =>
  //     import('@/modules/account-register/apps/AccountRegisterAdvisorAppSP.vue');
  //   const { router } = await import(
  //     '@/modules/account-register/routers/accountRegisterAdvisorRouterSP'
  //   );
  //   return new Vue({
  //     router,
  //     render: h => h(Component, { props }),
  //   });
  // },

  /* profile (SP) */
  'profile-template-sp': async props => {
    Vue.use(VueCompositionAPI);
    const Component = () => import('@/modules/profile/apps/ProfileAppSP.vue');
    const { router } = await import(
      '@/modules/profile/routers/profileRouterSP'
    );
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },

  'profile-correct-job-history-app-sp': async props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/profile/apps/ProfileCorrectJobHistoryAppSP.vue');
    const { router } = await import(
      '@/modules/profile/routers/profileCorrectJobHistoryRouterSP'
    );

    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },

  /* profile */
  'profile-template': async props => {
    Vue.use(VueCompositionAPI);
    const Component = () => import('@/modules/profile/apps/ProfileApp.vue');
    const { router } = await import('@/modules/profile/routers/profileRouter');
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },

  'profile-correct-job-history-app': async props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/profile/apps/ProfileCorrectJobHistoryApp.vue');
    const { router } = await import(
      '@/modules/profile/routers/profileCorrectJobHistoryRouter'
    );

    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },

  /* account-settings */
  'account-settings-personal-info': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsPersonalInfoApp.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  // TODO: 不要なコードを削除する CU-86ep79rdb
  // 'account-settings-bank': props => {
  //   Vue.use(VueCompositionAPI);
  //   const Component = () =>
  //     import('@/modules/account-settings/apps/AccountSettingsBankApp.vue');
  //   return new Vue({
  //     render: h => h(Component, { props }),
  //   });
  // },

  // 'account-settings-bank-sp': props => {
  //   Vue.use(VueCompositionAPI);
  //   const Component = () =>
  //     import('@/modules/account-settings/apps/AccountSettingsBankAppSP.vue');
  //   return new Vue({
  //     render: h => h(Component, { props }),
  //   });
  // },

  'account-settings-phone-number': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsPhoneNumberApp.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'no-phone-verification-warning-modal': props => {
    const Component = () =>
      import(
        '@/modules/account-settings/organisms/NoPhoneVerificationWarningModal.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'account-settings-credit-card': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsCreditCardApp.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'account-settings-credit-card-payment': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsCreditCardPaymentApp.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'account-settings-paypal-payment': async props => {
    await setupPaypalButton(props.paypalClientId).catch(() => {});

    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsPaypalPaymentApp.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'account-settings-purchase-invoice-preview': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsPurchaseInvoicePreviewApp.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'account-settings-all-purchase-invoices-preview': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsAllPurchaseInvoicesPreviewApp.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'account-settings-transaction-invoice-preview': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsTransactionInvoicePreviewApp.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'account-settings-all-transaction-invoices-preview': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsAllTransactionInvoicesPreviewApp.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'account-settings-no-residence-warning-app': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsNoResidenceWarningApp.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* account-settings (SP) */
  'account-settings-personal-info-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsPersonalInfoAppSP.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'account-settings-phone-number-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsPhoneNumberAppSP.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'no-phone-verification-warning-modal-sp': props => {
    const Component = () =>
      import(
        '@/modules/account-settings/organisms/NoPhoneVerificationWarningModalSP.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'account-settings-credit-card-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsCreditCardAppSP.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'account-settings-credit-card-payment-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsCreditCardPaymentAppSP.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'account-settings-paypal-payment-sp': async props => {
    await setupPaypalButton(props.paypalClientId).catch(() => {});

    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsPaypalPaymentAppSP.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'account-settings-no-residence-warning-app-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/account-settings/apps/AccountSettingsNoResidenceWarningAppSP.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* teamplan-register */
  'teamplan-register-app': async props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/teamplan-register/apps/TeamplanRegisterApp.vue');
    const { router } = await import(
      '@/modules/teamplan-register/routers/router'
    );
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },

  /* teamplan */
  'teamplan-app': async props => {
    Vue.use(VueCompositionAPI);
    const Component = () => import('@/modules/teamplan/apps/TeamplanApp.vue');
    const { router } = await import('@/modules/teamplan/routers/router');
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },
  'project-topic-bookmark-dropdown-menu': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/teamplan/organisms/ProjectBookmarkDropdownMenu/TopicBookmarkDropdownMenu.vue'
      );
    return new Vue({
      provide: {
        [provideTeamIdKey.valueOf()]: props.teamId,
      },
      render: h => h(Component, { props }),
    });
  },
  'project-issue-dropdown-menu': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules/teamplan/organisms/ProjectIssueDropdownMenu/ProjectIssueDropdownMenu.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'teamplan-transaction-report-preview': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/teamplan/apps/TeamplanTransactionReportPreviewApp.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  /* tutorial-compliance */
  'tutorial-compliance-app': async props => {
    const Component = () =>
      import('@/modules/tutorial/apps/TutorialComplianceApp.vue');
    const { router } = await import('@/modules/tutorial/routers/router');
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },

  /* tutorial-compliance (SP) */
  'tutorial-compliance-app-sp': async props => {
    const Component = () =>
      import('@/modules/tutorial/apps/TutorialComplianceAppSP.vue');
    const { router } = await import('@/modules/tutorial/routers/routerSP');
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },

  /* now */
  // TODO: 不要なコードを削除する CU-86ep2bxur
  // 'now-template': async props => {
  //   Vue.use(VueCompositionAPI);
  //   const Component = () => import('@/modules/visasq-now/apps/NowApp.vue');
  //   const { router } = await import('@/modules/visasq-now/routers/nowRouter');
  //   return new Vue({
  //     router,
  //     render: h => h(Component, { props }),
  //   });
  // },

  // 'now-template-sp': async props => {
  //   Vue.use(VueCompositionAPI);
  //   const Component = () => import('@/modules/visasq-now/apps/NowAppSP.vue');
  //   const { router } = await import('@/modules/visasq-now/routers/nowRouterSP');
  //   return new Vue({
  //     router,
  //     render: h => h(Component, { props }),
  //   });
  // },

  /* [公開設定リニューアル] 非公開 -> 限定公開のお知らせ */
  'request-to-enterprise-internal-modal': props => {
    const Component = () =>
      import(
        '@/modules/privacy-setting-change-notification/organisms/RequestToEnterpriseInternalModal.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'request-to-enterprise-internal-modal-sp': props => {
    const Component = () =>
      import(
        '@/modules/privacy-setting-change-notification/organisms/RequestToEnterpriseInternalModalSP.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  /* [公開設定リニューアル] 公開設定リニューアルのお知らせ */
  'privacy-setting-renewal-notify-modal': props => {
    const Component = () =>
      import(
        '@/modules/privacy-setting-change-notification/organisms/PrivacySettingRenewalNotifyModal.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'privacy-setting-renewal-notify-modal-sp': props => {
    const Component = () =>
      import(
        '@/modules/privacy-setting-change-notification/organisms/PrivacySettingRenewalNotifyModalSP.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  /* チュートリアル */
  'tutorial-advisor-app': props => {
    const Component = () =>
      import('@/modules/tutorial/apps/TutorialAdvisorApp.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'tutorial-advisor-app-sp': props => {
    const Component = () =>
      import('@/modules/tutorial/apps/TutorialAdvisorAppSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  'user-template': props => {
    Vue.use(VueCompositionAPI);
    const Component = () => import('@/modules/user/apps/UserApp.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
  'user-template-sp': props => {
    Vue.use(VueCompositionAPI);
    const Component = () => import('@/modules/user/apps/UserAppSP.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* advisor-search */
  'advisor-search-app': async props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/advisor-search/apps/AdvisorSearchApp.vue');
    const { router } = await import(
      '@/modules/advisor-search/routers/advisorSearchRouter'
    );
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },
  'advisor-search-app-sp': async props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules/advisor-search/apps/AdvisorSearchAppSP.vue');
    const { router } = await import(
      '@/modules/advisor-search/routers/advisorSearchRouterSP'
    );
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },

  /* ======================================== */
  /*                  GLOBAL                  */
  /* ======================================== */

  /* welcome */
  'en-welcome': async props => {
    const Component = () =>
      import('@/modules-en/welcome/templates/EnWelcomeTemplate.vue');
    const { router } = await import('@/modules-en/welcome/routers/router');
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },

  /* profile-edit */
  'en-profile-edit': props => {
    const Component = () =>
      import('@/modules-en/profile/pages/EnProfileEditPage.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* compliance-tutorial */
  'en-compliance-tutorial-template': async props => {
    const Component = () =>
      import(
        '@/modules-en/compliance-tutorial/templates/EnComplianceTutorialTemplate.vue'
      );
    const { router } = await import(
      '@/modules-en/compliance-tutorial/routers/router'
    );
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },

  /* guidance */
  'en-guidance': props => {
    const Component = () =>
      import('@/modules-en/guidance/pages/EnGuidancePage.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* screening-top */
  'en-screening-top': props => {
    const Component = () =>
      import('@/modules-en/screening/pages/EnScreeningTopPage.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* screening-not-found */
  'en-screening-not-found': props => {
    const Component = () =>
      import('@/modules-en/screening/pages/EnScreeningNotFoundPage.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* screening-closed */
  'en-screening-closed': props => {
    const Component = () =>
      import('@/modules-en/screening/pages/EnScreeningClosedPage.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* screening */
  'en-screening-template': async props => {
    const Component = () =>
      import('@/modules-en/screening/templates/EnScreeningTemplate.vue');
    const { router } = await import('@/modules-en/screening/routers/router');
    return new Vue({
      router,
      render: h => h(Component, { props }),
    });
  },

  /* payee-edit */
  'en-payee-account-edit': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules-en/payee/pages/EnPayeeEditPage.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* proposal-deliver */
  'en-proposals-deliver': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules-en/proposals/pages/EnProposalsDeliverPage.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* proposal-purchase-invoice */
  'en-proposals-purchase-invoice': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import('@/modules-en/proposals/pages/EnProposalsPurchaseInvoicePage.vue');
    return new Vue({
      render: h => h(Component, { props }),
    });
  },

  /* proposal-all-purchase-invoices */
  'en-all-proposals-purchase-invoices': props => {
    Vue.use(VueCompositionAPI);
    const Component = () =>
      import(
        '@/modules-en/proposals/pages/EnAllProposalsPurchaseInvoicesPage.vue'
      );
    return new Vue({
      render: h => h(Component, { props }),
    });
  },
} as Collection;
